import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/page.tsx");
